module.exports = __webpack_public_path__ + "media/images/ringrevenue/book_open-0ba89b9fbe7e88d4c6896ed0a1f495aa.png";